export default __webpack_public_path__ + "static/fca-color-8cc618e2747bfe5816920f8ac34e1dcd.svg";